import { Injectable } from '@angular/core';
import { NodoEntity, EstructuraNodo } from '../servicio-formato-asistencial.service';

@Injectable({
  providedIn: 'root'
})
export class NodoService {

  constructor() { }

  parseVal(val: string): any {
    if (val && val.trim().length > 0 ) {
      if (val.startsWith('%')) {
        val = val.substring(1);
      }

      if (val.startsWith('{') && val.endsWith('}')) {
        const obj = {};
        val = val.substring(1, val.length - 1);
        let indxS = 0, indx = 0;
        while ((indx = val.indexOf(':', indx)) !== -1) {
          const key = val.substring(indxS, indx);
          let value = '';
          switch (val.charAt(indx + 1)) {
            case '%' : {
              const strLength = val.substring(indx + 3, (indx = val.indexOf(']', indx)));
              const length = Number(strLength);
              const valTemp = val.substring((indx += 2), (indx += length));
              value = `%{${valTemp}}`;
            } break;

            case '\'' : {
              value = this.encodeAndDecode(false, val.substring((indx += 2), (indx = val.indexOf('\'', indx))));
            } break;

            default: {
              value = 'ERROR PARSING VALUE';
              break;
            }
          }
          obj[key] = value;
          indxS = indx += 2;
        }
        return obj;
      }
    }
    return {};
  }

  encodeAndDecode(encode: boolean, val: string): string {
    if (encode) {
      return val.replace('\'', '%01').replace(':', '%02').replace(',', '%03');
    } else {
      return val.replace('%01', '\'').replace('%02', ':').replace('%03', ',');
    }
  }

  groupNodosByType(nodos: NodoEntity[]): { estructura ?: EstructuraNodo, nodos?: NodoEntity[]} | undefined {
    const map = {};
    if (nodos && nodos.length > 0) {
      nodos.forEach((n: NodoEntity) => {
        const codigoEstructura = n.codigoEstructura;
        if (map[codigoEstructura]) {
          const nds: NodoEntity[] = map[codigoEstructura];
          nds.push(n);
          map[codigoEstructura] = nds;
        } else {
          const nds: NodoEntity[] = [];
          nds.push(n);
          map[codigoEstructura] = nds;
        }
      });
      return map;
    }
    return null;
  }

  parseGroupFromValueNodo(pregunta: NodoEntity): { key ?: string, value ?: string} {
    const cadena = pregunta.valor ? pregunta.valor : null;
    return this.parseGroupFromValueCadena(cadena);
  }

  parseGroupFromValueCadena(cadena: string): { key ?: string, value ?: string} {
    const map = {};
    if (cadena && cadena.length > 0) {
      let p = 0;
      while ((p = cadena.indexOf('[', p) + 1) !== 0) {
        const end = cadena.indexOf(']', p);
        const value = cadena.substring(p, end);
        const split: string[] = value.split(',');
        map[split[0]] = split[1];
      }
    }
    return map;
  }
}
